import React from "react";
import { useStylesGeneral } from '../../styles/StyleComponents';
import "../../styles/site.css";
// import AdvancedMaterialTableExample from "../../common/ComponentesCS/AdvancedMaterialTableExample";
// import AdvancedMaterialTableExample from "../../common/ComponentesCS/AdvancedMaterialTableExample";

//title: Titulo de la tabla ""
//data: datos del Grid []
//columns: columnas de la tabla []
//selectedRow: Fila seleccionada 
//actions: Botones y funciones del grid []
//selection: Valida si se muestra o no los checks de seleccion (true o false)
//title: Titulo de la tabla ""
//pageSize: El número de registros por pagina de la vista
//showTitle: Muestro o no el titulo de la tabla
//pageSizeOptions: Opciones de numero de registro de paginados []

function MaterialTableCS() {
  const classes = useStylesGeneral();

  return (<>
    <label className='tituloSeccion'>Tablas (Grid)</label>
    <div className={classes.root}>
      {/* <AdvancedMaterialTableExample /> */}
    </div>
  </>)
}

export default React.memo(MaterialTableCS);